/*
// top of your main entry (before anything async)
window.__appBootMarkStart = performance.now()

// after your app has fully initialized UI/event handlers:
if (window.__appBootOk) window.__appBootOk('app-ready')
*/

import "./polyfills/url_search_params_iterator";
import "./bugsnag";
import components from "./componentRegistry";

import { Application } from "@hotwired/stimulus"
import { Controller as n } from "@hotwired/stimulus"

import "./controllers"

import "@hotwired/turbo-rails"
import { Turbo } from "@hotwired/turbo-rails"

Turbo.session.drive = false

import "./legacy.js"

import ReactRailsUJS from "react_ujs";
ReactRailsUJS.useContext(components);
ReactRailsUJS.detectEvents();



// mark ready which will trigger ad load
window.__markAppBootReady && window.__markAppBootReady();
